import { pattern } from "./pattern";

export const emailValidator = (value) => {
    const emailRegex = new RegExp(pattern.email);
    if (emailRegex.test(value)) return true;
    else return false;
}